import { render, staticRenderFns } from "./ProjectRevenuesPage.vue?vue&type=template&id=1e47a2ba&scoped=true"
import script from "./ProjectRevenuesPage.vue?vue&type=script&lang=ts"
export * from "./ProjectRevenuesPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRevenuesPage.vue?vue&type=style&index=0&id=1e47a2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e47a2ba",
  null
  
)

export default component.exports